import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import LoadingSpinner from '../../../../loading-spinner';
import PropdocsModal from '../../../../modal/PropdocsModal';

interface Props {
  show: boolean;
  onHide: () => void;
  handler?: () => void;
  isLoading?: boolean;
  title?: string;
  submitButtonTitle: string;
  cancelButtonTitle: string;
  children?: React.ReactNode;
}

export function DocumentDealActionModal({
  onHide,
  handler = () => {},
  cancelButtonTitle,
  submitButtonTitle,
  isLoading,
  show,
  title,
  children,
}: Props) {
  return (
    <PropdocsModal size="lg" show={show} setShow={onHide} title={<>{title || 'Modal'}</>}>
      <>
        <section className="document-wizard-summary-modal" style={{ marginBottom: '1.5rem' }}>
          {children}
        </section>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: '1.5rem' }}>
          <button type="button" className="btn btn-outline-secondary" onClick={onHide} disabled={isLoading}>
            <FormattedMessage
              id="lease-document-wizard-preview-send-offer.cta.cancel"
              defaultMessage={`${cancelButtonTitle || 'Cancel'}`}
            />
          </button>
          <button type="button" className="btn btn-secondary" onClick={handler} disabled={isLoading}>
            <FormattedMessage
              id="lease-document-wizard-preview-send-offer.cta.send-to-tenant"
              defaultMessage={submitButtonTitle}
            />
            {isLoading && <LoadingSpinner />}
          </button>
        </div>
      </>
    </PropdocsModal>
  );
}
